/* eslint-disable camelcase */
const SET_DIM_SCREEN_SCROLL_Y = 'SET_DIM_SCREEN_SCROLL_Y'
const RESET_DIM_SCREEN_SCROLL_Y = 'RESET_DIM_SCREEN_SCROLL_Y'

export function setDimScreenScrollY(payload) {
  return { type: SET_DIM_SCREEN_SCROLL_Y, payload }
}

export function resetDimScreenScrollY() {
  return { type: RESET_DIM_SCREEN_SCROLL_Y }
}

const initialState = {
  scrollY: 0
}

export default function(state = initialState, { type, payload }) {
  switch (type) {
    case SET_DIM_SCREEN_SCROLL_Y: {
      return { scrollY: state.scrollY + payload }
    }
    case RESET_DIM_SCREEN_SCROLL_Y: {
      return initialState
    }
    default:
      return state
  }
}
